import { Component, EventEmitter, Inject, inject, Input, OnInit, Output } from '@angular/core';
import { API_STATUS, ApiEnvNames, ERROR_RESPONSE, ExportConfig } from '../../../model/api.model';
import { CommonUtils } from '../../../utils/common.utils';
import { CommonService } from '../../../services/common.service';
import { SPINNER_AREA, SpinnerArea } from '../../../model/common.model';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from "@angular/material/icon";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BrandEditileExportSearchConfig } from '../../../model/tenure/brand-tenure.model';
import { FieldNames } from '../../../model/form-fields.model';
import { CommonModule, DatePipe } from '@angular/common';
import { EXCEL_EXTENSION } from '../../../services/excel-export.service';
import { CamelCasePipe } from '../../../utils/camel-case.pipe';
import { LucideCalendar } from '@lucide/angular';
import { LoadingSkeletonComponent } from '../../../layout/loading-skeleton/loading-skeleton.component';

@Component({
  selector: 'app-tenure-history',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule, CamelCasePipe, LoadingSkeletonComponent],
  providers: [DatePipe], 
  templateUrl: './tenure-history.component.html',
  styleUrl: './tenure-history.component.scss'
})
export class TenureHistoryComponent implements OnInit {
  readonly iconToShow = LucideCalendar;
  @Input() onLoadFetch = true;
  @Input() type: 'history'|'info' = 'history';
  @Output() btnClose: EventEmitter<any> = new EventEmitter<any>();
  public createdOn ="Aug 26, 2025";
  private readonly commonUtils = inject(CommonUtils);
  private readonly service = inject(CommonService);
  public spinnerName: SpinnerArea = SPINNER_AREA['Popup'];
  public tenureHistory: any = [];
  public latestHistory:any = [];
  public showAttachment = false;
  public isLoadingHistory = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data:any){}

  ngOnInit() {
    this.showAttachment = this.service.isTenureAdmin;
    if(this.onLoadFetch){
      this.fetchTenureHistory()
    }else{
      this.tenureHistory = this.handleResponse([this.latestHistory])
    }
  }
  fetchTenureHistory() {
    const searchConfig = structuredClone(this.data['tenureConfig']);
    searchConfig['body'][FieldNames['SpinId']] = this.data['spinId']
    searchConfig['body']['brand'] = this.data['brand'];
    if(searchConfig['body']?.type ==='dealer'){
        searchConfig['body']['dealerCode'] = this.data['dealerCode'];
    }
    if(searchConfig['body']?.type ==='job'){
      searchConfig['body']['dealerCode'] = this.data['dealerCode'];
      searchConfig['body']['jobCode'] = this.data['jobCode'];
    }
    this.isLoadingHistory = true;
    this.tenureHistory = []
    this.service.getDataFromDataSource(searchConfig, ApiEnvNames['Tenure']).then(response => {
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          this.tenureHistory = this.handleResponse(response.result)
        }
      }
    }).catch(err => {
      console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);
    }).finally(() => {
      this.isLoadingHistory = false;
    })

  }
  handleResponse(dataArr:any){
    const formattedData = dataArr.map((data: any) => {
      if (data[FieldNames['Attachment']]) {
        data[FieldNames['Attachment']] = JSON.parse(data[FieldNames['Attachment']])
      }
      if(data['updatedOn']){
        data['updatedOn'] = new Date(data['updatedOn']).toISOString().split('T')[0]
      }
      return data
    })
    const groupData = this.commonUtils.groupBy(formattedData, 'updatedOn');
    const result:any = [];
    Object.keys(groupData).forEach(key=>{
      result.push({
        createdon: key,
        details: groupData[key]
      })
    })
    return result;
  }
  closeBtnOnClick(_event: any) {
    this.btnClose.emit({})
  }
  // downloadFile(file:any){
  downloadFile = (file:any) => {
    const exportConfig: ExportConfig = {
      environment: ApiEnvNames['StaffMaster'],
      fileExtension: EXCEL_EXTENSION,
      searchParameters: BrandEditileExportSearchConfig,
      exportFileName: 'OEM_file_export',
      tableSchema: undefined
    };
    if(file) {
      this.commonUtils.spinner('show',this.spinnerName);
      this.service.downloadExcelFromS3(file, exportConfig).then(()=>{
        this.commonUtils.spinner('hide',this.spinnerName);
      }).catch(()=>{
        this.commonUtils.spinner('hide',this.spinnerName);
      })
    }
  }  
}
